module.exports = __webpack_public_path__ + "img/client_4.7740b03a.jpg";